import { Controller } from "@hotwired/stimulus"
import "emoji-picker-element"

export default class extends Controller {
  static targets = ["display", "hidden", "dropdown", "maxSelect", "criteriaRow"]

  connect() {
    this.dropdownTarget.querySelector("emoji-picker")
      .addEventListener("emoji-click", (e) => this.onEmojiClick(e))
  }

  toggle(event) {
    event.stopPropagation()
    this.dropdownTarget.classList.toggle("hidden")
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add("hidden")
    }
  }

  onEmojiClick(event) {
    this.displayTarget.textContent = event.detail.unicode
    this.hiddenTarget.value = event.detail.unicode
    this.dropdownTarget.classList.add("hidden")
  }

  updateCriteriaVisibility() {
    const max = Number(this.maxSelectTarget.value)
    this.criteriaRowTargets.forEach((row) => {
      row.hidden = Number(row.dataset.ratingValue) > max
    })
  }
}
